import {ControlValueAccessor} from "@angular/forms";
import {ChangeDetectorRef, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild} from "@angular/core";

export abstract class AbstractField implements ControlValueAccessor, OnDestroy {
    @Input() inputId: string;
    @Input() label: string;
    @Input() link: string;
    @Input() placeholder: string;
    @Input() message: string;
    @Input() translationParams: any = {};
    @Input() readOnly: boolean = false;
    @Input() disabled: boolean = false;

    @Output() valueChange: EventEmitter<any> = new EventEmitter();
    @Output() onActivateLink: EventEmitter<void> = new EventEmitter();

    // noinspection Annotator
    @ViewChild("input") protected inputER: ElementRef;

    private destroyed: boolean = false;
    private _value: any;
    private onChange = (_: any): void => {};
    private onTouched = (): void => {};

    protected constructor(protected changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }

    @Input()
    public set value(value: any) {
        if (value !== this._value) {
            this._value = value;
            this.onChange(value);
            this.valueChange.emit(value);
        }
    }

    public get value(): any {
        return this._value;
    }

    public registerOnChange(fn: (_: any) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public writeValue(value: any): void {
        if (!this.destroyed) {
            this._value = value;
            this.changeDetectorRef.detectChanges();
        }
    }

    public focus(): void {
        if (this.inputER) {
            this.inputER.nativeElement.focus();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/field/abstract-field.ts